import { render, staticRenderFns } from "./RecordProcessStepper.vue?vue&type=template&id=2c9ff6af&"
import script from "./RecordProcessStepper.vue?vue&type=script&lang=js&"
export * from "./RecordProcessStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports